type WindowWithEnv = Window & {
  env?: {
    REACT_APP_VERSION?: string;
  };
};

export const getVersion = () => {
  return (window as WindowWithEnv).env?.REACT_APP_VERSION ?? 'local';
};
